module.exports = __webpack_public_path__ + "cement/img/图像 294@2x.e2eee02b.png";